import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import * as parentConstants from 'modules/QAQC/QAQCReportPage/constants';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as constants from './constants';
import { CylinderBreakingTestParams } from './constants';
import useCylinderBreakingTestQueries, { CylinderBreakingTestQueries } from './useCylinderBreakingTestQueries';

const CylinderBreakingTestPage = lazyWithSuspense(() => import('./CylinderBreakingTestPage'));

const page: Page<constants.CylinderBreakingTestParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage<CylinderBreakingTestParams, CylinderBreakingTestQueries>({
    WrappedPage: CylinderBreakingTestPage,
    titleFn: () => i18n._(constants.TITLE),
    pageDataHook: useCylinderBreakingTestQueries,
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
